import * as React from "react"
import styled from "styled-components"
import { theme } from "../../theme"
import { ArrowButtonDown, ArrowButtonLeft, ArrowButtonRight, ArrowButtonUp } from "../icons/ArrowButtonIcons"

interface ArrowButtonProps {
  direction: "r" | "l" | "d" | "u"
  onClick?: () => void

  disabled?: boolean
}

const ButtonContainer = styled.div<{ disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};

  :hover {
    opacity: ${(props) => (props.disabled ? 1 : 0.7)};
  }
`

const ArrowButton: React.FunctionComponent<ArrowButtonProps> = ({ onClick, direction, disabled }) => {
  const color = disabled ? theme.colors.greyDark : theme.colors.greyDarker

  const icon = React.useMemo(() => {
    switch (direction) {
      case "r":
        return <ArrowButtonRight color={color} />
      case "l":
        return <ArrowButtonLeft color={color} />
      case "d":
        return <ArrowButtonDown color={color} />
      default:
        return <ArrowButtonUp color={color} />
    }
  }, [direction, disabled])

  return (
    <ButtonContainer onClick={disabled ? undefined : onClick} disabled={disabled}>
      {icon}
    </ButtonContainer>
  )
}

export default ArrowButton
